module.exports = __webpack_public_path__ + "img/banner.5ac5113b.png";